import React, { useState } from 'react';

import { GridApi } from 'ag-grid-community';

import { Paper } from '@material-ui/core';

import TranslationHelper from '../../helpers/TranslationHelper';

import EditOverlay from '../../components/EditOverlay';

import View from '../../components/View';
import PageContent from '../../components/PageContent';

import { useStyles } from './Themable.hooks';
import TicketsGrid from '../../features/Tickets/components/TicketsGrid';
import { useTicketsPaneVisible } from '../../features/Tickets/state/index.hooks';
import TicketsPane from '../../features/Tickets/components/TicketsPane/TicketPane';

import AppConfig from '../../constants/AppConfig';

const TicketsPage = () => {
    const [gridApi, setGridApi] = useState<GridApi | null>(null);

    const enterpriseKey = AppConfig?.instance.getConfigKey(
        AppConfig.PROPERTY_GRID
    )?.key;
    const classes = useStyles();
    const isTicketsPaneVisible = useTicketsPaneVisible();
    const refreshGrid = () => {
        enterpriseKey
            ? gridApi?.refreshServerSideStore({})
            : gridApi?.purgeInfiniteCache();
    };

    const ticketsPaneClass = isTicketsPaneVisible
        ? classes.visiblePane
        : classes.hiddenPane;
    return (
        <View title={TranslationHelper.translate('Tickets')}>
            <PageContent>
                <div className={classes.pageWrapper} id="ticketsPage">
                    <div className={ticketsPaneClass}>
                        <TicketsGrid
                            gridApi={gridApi}
                            setGridApi={setGridApi}
                            refreshGrid={refreshGrid}
                        />
                    </div>

                    {isTicketsPaneVisible && (
                        <Paper className={classes.paneWrapper}>
                            <TicketsPane refreshGrid={refreshGrid} />
                        </Paper>
                    )}
                </div>
            </PageContent>
            <EditOverlay />
        </View>
    );
};

export default TicketsPage;
